module.exports = __webpack_public_path__ + "static/button2-a8a1d99e0c14e8a650c3b4525bb21004.png";